/* SearchHeader.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["isEmbedded"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["isEmbedded"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["aria-labelledby"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _51 = "@media (min-width:64rem){._ue5g1pcy{margin:var(--_4xsayh)}}";
const _50 = "@media (min-width:64rem){._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}._glte7vkz{width:1pc}._165t7vkz{height:1pc}}";
const _49 = "._x5dbugt7:focus-visible:not(:active){outline:2px solid var(--ds-border-focused,#388bff)}";
const _48 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _47 = "._1e0c1ule{display:block}";
const _46 = "._1e0cglyw{display:none}";
const _45 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _44 = "._4t3i1tcg{height:24px}";
const _43 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _42 = "._1ygbugt7:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _41 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _40 = "._80omtlke{cursor:pointer}";
const _39 = "._1bah1h6o{justify-content:center}";
const _38 = "._1bsb1ady{width:44px}";
const _37 = "._4t3i1ady{height:44px}";
const _36 = "._11q7glyw{background:none}";
const _35 = "._1yt4l735{padding:var(--ds-space-0,0) var(--ds-space-050,4px) var(--ds-space-0,0) var(--ds-space-050,4px)}";
const _34 = "._zulpv77o{gap:var(--ds-space-025,2px)}";
const _33 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _32 = "._1yt4xmni{padding:var(--ds-space-0,0) var(--ds-space-0,0) var(--ds-space-0,0) var(--ds-space-100,8px)}";
const _31 = "._1yt417l2{padding:var(--ds-space-100,8px) var(--ds-space-200,1pc) var(--ds-space-100,8px) var(--ds-space-100,8px)}";
const _30 = "@media (min-width:64rem){._pdlmu2gc{gap:var(--ds-space-100,8px)}._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}}";
const _29 = "._4cvr1h6o{align-items:center}";
const _28 = "._1e0c1txw{display:flex}";
const _27 = "._18u0idpf{margin-left:0}";
const _26 = "._otyridpf{margin-bottom:0}";
const _25 = "._2hwxidpf{margin-right:0}";
const _24 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import CrossIcon from '@atlaskit/icon/core/cross-circle';
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import SearchIcon from '@atlaskit/icon/glyph/search';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React, { forwardRef } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _23 = "._tdaxglyw[type=search]::-webkit-search-cancel-button{display:none}";
const _22 = "._1idr1gjq::placeholder{color:var(--ds-text-subtle,#44546f)}";
const _21 = "._1idr1gjq::-ms-input-placeholder{color:var(--ds-text-subtle,#44546f)}";
const _20 = "._18ql1nua{-webkit-tap-highlight-color:var(--ds-surface,#FFFFFF)}";
const _19 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const _18 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const _17 = "._12y3idpf{outline-width:0}";
const _16 = "._16jlkb7n{flex-grow:1}";
const _15 = "._vwz41k8s{line-height:1.5rem}";
const _14 = "._k48p1nn1{font-weight:400}";
const _13 = "._zg8l4jg8{font-style:normal}";
const _12 = "._1wyb1j6v{font-size:1rem}";
const _11 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _10 = "._1bsb1osq{width:100%}";
const _9 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._12y31o36{outline-width:medium}";
const _3 = "._1qu2glyw{outline-style:none}";
const _2 = "._12ji1r31{outline-color:currentColor}";
const _ = "._19itglyw{border:none}";
const Input = /*#__PURE__*/forwardRef((_ref, __cmplr) => {
  let {
      as: C = "input",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1fxt _1bsb1osq _ect418aq _1wyb1j6v _zg8l4jg8 _k48p1nn1 _vwz41k8s _16jlkb7n _12y3idpf _r06hglyw _bfhkvuon _18ql1nua _1idr1gjq _tdaxglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Input.displayName = 'Input';
}
const Form = /*#__PURE__*/forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "form",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      isEmbedded
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_24, _25, _26, _27, _19, _28, _10, _29, _30, _31, _32, _33, _34]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _1e0c1txw _1bsb1osq _4cvr1h6o _pdlmu2gc _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf", __cmplp.isEmbedded ? "_1yt417l2" : "_1yt4xmni", __cmplp.isEmbedded ? "_zulpu2gc" : "_zulpv77o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Form.displayName = 'Form';
}
const BackButtonMobile = /*#__PURE__*/forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_35, _, _36, _37, _38, _28, _39, _29, _40, _41, _42, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4l735 _19itglyw _11q7glyw _4t3i1ady _1bsb1ady _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _syaz131l _1ygbugt7 _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BackButtonMobile.displayName = 'BackButtonMobile';
}
const SearchButtonDesktop = /*#__PURE__*/forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  const {
      isEmbedded
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_44, _45, _46, _47]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1tcg _dm251ule", !__cmplp.isEmbedded ? "_1e0cglyw" : "_1e0c1ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchButtonDesktop.displayName = 'SearchButtonDesktop';
}
const ClearButton = /*#__PURE__*/forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_36, _, _40, _18, _48, _38, _37, _49, _50]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7glyw _19itglyw _80omtlke _r06hglyw _syaz1gjq _1bsb1ady _4t3i1ady _x5dbugt7 _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _glte7vkz _165t7vkz", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ClearButton.displayName = 'ClearButton';
}
const ClearButtonStyle = null;
export const SearchHeader = /*#__PURE__*/forwardRef(
// eslint-disable-next-line max-lines-per-function, complexity
(_ref6, inputRef) => {
  var _current3;
  let {
    autocomplete,
    handleEnterKeyPress,
    handleBackClick,
    clearSearchInput,
    onBlur,
    onFocus,
    onKeyDown,
    onClearTextKeyDown,
    isEmbedded,
    showFullScreenComponent = false,
    backButtonRef
  } = _ref6;
  const onFormSubmit = e => {
    var _current;
    e.preventDefault();
    const query = inputRef === null || inputRef === void 0 ? void 0 : (_current = inputRef.current) === null || _current === void 0 ? void 0 : _current.value;
    handleEnterKeyPress(query || '');
  };
  const inputProp = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
    autoFocus: !isEmbedded,
    maxLength: 200
  });
  const rootProps = !isEmbedded ? autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}) : {};
  const _ref7 = (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
      inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
      autoFocus: !isEmbedded,
      maxLength: 200
    })) || {},
    {
      'aria-labelledby': ariaLabelledby
    } = _ref7,
    inputProps = _objectWithoutProperties(_ref7, _excluded8);
  const searchFieldProps = _objectSpread(_objectSpread({}, rootProps), inputProps);
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    var _current2;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Form, _objectSpread(_objectSpread({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getFormProps({
        inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
      })), {}, {
        onSubmit: onFormSubmit,
        onBlur: onBlur,
        onFocus: onFocus,
        isEmbedded: isEmbedded,
        onKeyDown: onKeyDown,
        className: "dont-default-focus" // this classname is added to prevent the autofocus on load in Jira
        ,
        children: [handleBackClick && /*#__PURE__*/_jsx(BackButtonMobile, {
          onClick: handleBackClick,
          ref: backButtonRef,
          type: "button",
          children: /*#__PURE__*/_jsx(ArrowLeftIcon, {
            label: "back button"
          })
        }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
          ref: inputRef
        }, searchFieldProps), {}, {
          "aria-label": (inputProp === null || inputProp === void 0 ? void 0 : inputProp.placeholder) || 'Search for apps within Marketplace'
        }))]
      })), !showFullScreenComponent && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : (_current2 = inputRef.current) === null || _current2 === void 0 ? void 0 : _current2.value) && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_51]
        }), /*#__PURE__*/_jsx(ClearButton, {
          onClick: clearSearchInput,
          onKeyDown: onClearTextKeyDown,
          className: ax(["_ue5g1pcy"]),
          style: {
            "--_4xsayh": ix("0 ".concat("var(--ds-space-200, 16px)"))
          },
          children: /*#__PURE__*/_jsx(CrossIcon, {
            label: "Clear search input field"
          })
        })]
      }), /*#__PURE__*/_jsx(SearchButtonDesktop, {
        isEmbedded: isEmbedded,
        children: /*#__PURE__*/_jsx(SearchIcon, {
          label: "search"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Form, _objectSpread(_objectSpread({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getFormProps({
      inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
    })), {}, {
      onSubmit: onFormSubmit,
      onBlur: onBlur,
      onFocus: onFocus,
      isEmbedded: isEmbedded,
      onKeyDown: onKeyDown,
      className: "dont-default-focus" // this classname is added to prevent the autofocus on load in Jira
      ,
      children: [handleBackClick && /*#__PURE__*/_jsx(BackButtonMobile, {
        onClick: handleBackClick,
        ref: backButtonRef,
        type: "button",
        children: /*#__PURE__*/_jsx(ArrowLeftIcon, {
          label: "back button"
        })
      }), /*#__PURE__*/_jsx(SearchButtonDesktop, {
        isEmbedded: isEmbedded,
        children: /*#__PURE__*/_jsx(SearchIcon, {
          label: "search"
        })
      }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
        ref: inputRef
      }, searchFieldProps), {}, {
        "aria-label": (inputProp === null || inputProp === void 0 ? void 0 : inputProp.placeholder) || 'Search for apps within Marketplace'
      }))]
    })), !showFullScreenComponent && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : (_current3 = inputRef.current) === null || _current3 === void 0 ? void 0 : _current3.value) && /*#__PURE__*/_jsx(ClearButton, {
      onClick: clearSearchInput,
      onKeyDown: onClearTextKeyDown,
      children: /*#__PURE__*/_jsx(SelectClearIcon, {
        label: "Clear search input field",
        size: "small",
        "aria-controls": "search-input"
      })
    })]
  });
});
SearchHeader.displayName = 'SearchHeader';